const Dropdown = ({ handleChange, value, name, options }) => {
  return (
    <div className="flex">
      <select
        onChange={handleChange}
        value={value}
        name={name}
        className="rounded px-2 py-1 shadow shadow-secondary"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
